<!-- <app-festival-decoration></app-festival-decoration> -->

@if (!shouldHideLogin) {
<div class="login_page">
  <div class="illustration left" [class]="'entry-' + entryPoint">
    <img src="assets/images/login/all-sd.png" alt="Shade Illustration" />
    <img src="assets/images/login/cycl.png" alt="Bike Illustration" />
    <img src="assets/images/login/road.png" alt="Road Illustration" />
  </div>

  <div class="login_card">
    <img src="assets/images/login/techwyse-logo.png" class="logo" alt="TechWyse Logo" />
    <div class="quote">
      <img src="assets/images/login/smiley.png" class="smiley" alt="Smiley" />
      <span class="quote-text">
        {{ currentQuote }}
      </span>
    </div>

    @if (!showAgencySelection) {
    <form [formGroup]="loginForm" (ngSubmit)="onFormSubmit($event)">
      <div class="input_group">
        <div class="form-fields input-with-success">
          <input type="text" id="email" formControlName="email" placeholder="Enter Email"
            [class.is-invalid]="(email?.invalid && (isEmailTyping || email?.touched)) || email?.errors?.['backendError']"
            [class.is-valid]="email?.valid && email?.touched" (focus)="onEmailFocus()" (input)="onEmailInput()"
            (keyup)="onEmailKeyup($event)" appPreventLeadingSpace />
          @if (email?.valid && email?.touched) {
          <span class="success-circle"></span>
          }
          @if ((email?.invalid && (isEmailTyping || email?.touched)) || email?.errors?.['backendError']) {
          <span class="error-circle"></span>
          }
          @if (email?.invalid && (isEmailTyping || email?.touched) && !email?.errors?.['backendError']) {
          <div class="validation_error">
            {{ getErrorMessage('email') }}
          </div>
          }
        </div>
      </div>

      <div class="input_group mt-3">
        <div class="passcode_wrapper">
          <input [type]="showPassword ? 'text' : 'password'" formControlName="passcode" placeholder="Password"
            (input)="onPasswordInput()"
            [class.is-invalid]="(passcode?.invalid && (isPasswordTyping || passcode?.touched)) || passcode?.errors?.['backendError'] || email?.errors?.['backendError']"
            [class.is-valid]="passcode?.valid && passcode?.touched" (focus)="onPasswordFocus()" />
          @if (passcode?.valid && passcode?.touched && (errorMessage !== 'Password incorrect. Please try again')) {
          <span class="success-circle"></span>
          }
          @if ((passcode?.invalid && (isPasswordTyping || passcode?.touched)) || passcode?.errors?.['backendError'] ||
          email?.errors?.['backendError']) {
          <span class="error-circle"></span>
          }
          <span class="toggle" (click)="togglePassword()">{{ showPassword ? 'Hide' : 'Show' }}</span>
        </div>
        @if (passcode?.invalid && (isPasswordTyping || passcode?.touched) && !passcode?.errors?.['backendError']) {
        <div class="validation_error nw_pss_err">
          {{ getErrorMessage('passcode') }}
        </div>
        }
      </div>

      <div class="error_wrap" [ngClass]="{ 'show': errorMessage }">
        @if (errorMessage) {
        <div class="error_message">
          {{ errorMessage }}
        </div>
        }
      </div>
      <small class="back-link help_text"><a href="#/forgotpassword">Having trouble signing in? </a></small>
      <!-- <app-auth-festive-decoration page="login"></app-auth-festive-decoration> -->
      <button type="submit" [disabled]="isLoading">
        @if (!isLoading) {
        <span>Sign In</span>
        }
        @if (isLoading) {
        <app-spinner [size]="16"></app-spinner>
        }
      </button>
    </form>
    }

    @if (showAgencySelection) {
    <form [formGroup]="agencyForm" (ngSubmit)="onAgencyFormSubmit($event)">
      <h2>Select Agency</h2>
      <p>Please select an agency to continue</p>

      <div class="agency_tag_wrapper">
        @for (agency of visibleAgencies(); track agency._id) {
        <a [class.selected]="agencyForm.get('agency')?.value === agency._id" (click)="selectAgency(agency._id)"
          class="agency-tag">
          {{ agency.name }}
        </a>
        }
        <!-- <a 
          *ngFor="let agency of visibleAgencies" 
          [class.selected]="agencyForm.get('agency')?.value === agency.id"
          (click)="selectAgency(agency.id)"
          class="agency-tag"
        >
          <img src="{{ agency.name }}" alt="Agency Logo">
        </a> -->

        @if (agencies().length > 2) {
        <a class="next_btn" (click)="nextSlide()" [class.disabled]="currentIndex() >= agencies().length - 2">
          <svg width="13" height="6" viewBox="0 0 13 6" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.905273 0.758484L6.03861 4.75848L11.9053 0.758484" stroke-width="0.5" />
          </svg>
        </a>
        }
        @if (agencies().length > 2) {
        <a class="prev_btn" (click)="prevSlide()" [class.disabled]="currentIndex() === 0">
          <svg width="13" height="6" viewBox="0 0 13 6" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.905273 0.758484L6.03861 4.75848L11.9053 0.758484" stroke-width="0.5" />
          </svg>
        </a>
        }
      </div>
      <div class="btn_wrap">
        <a href="#" class="back-link" (click)="backToLogin($event)">Back to Login</a>
        <button type="submit" [disabled]="isLoading">
          @if (!isLoading) {
          <span>Continue</span>
          }
          @if (isLoading) {
          <app-spinner [size]="16"></app-spinner>
          }
        </button>
      </div>
    </form>
    }

    <img src="assets/images/login/workluge-logo.png" class="footer_logo" alt="WorkLuge Logo" />
  </div>

  <div class="illustration right">
    <img src="assets/images/login/str-grp.png" alt="Star Illustration" />
    <img src="assets/images/login/moon.png" alt="Moon Illustration" />
  </div>

</div>
}
<footer>© 2000–{{ currentYear }} Licenced Copyright by TechWyse. All rights reserved.</footer>